import type { ReactNode } from 'react';

import type { Tab } from './Tab';

type Args<
  TPrefix extends string,
  TLabel extends string | ReactNode,
  TValue extends string,
> = {
  prefix: TPrefix;
  label: TLabel;
  value: TValue;
  qaId?: string;
  href?: string;
  preventScrollReset?: boolean;
};

export function createTab<
  TPrefix extends string,
  TLabel extends string | ReactNode,
  TValue extends string,
>({
  prefix,
  label,
  value,
  qaId,
  href,
  preventScrollReset,
}: Args<TPrefix, TLabel, TValue>): Tab<TValue, TLabel, TPrefix> {
  const tabButtonId = `${prefix}-${value}-tab-button` as const;
  const tabPanelId = `${prefix}-${value}-tab-panel` as const;

  return {
    label,
    value,
    qaId,
    tabButtonId,
    tabPanelId,
    href,
    preventScrollReset,
  };
}
